import {OtsUIState} from "../../ots-ui-store";

export const getChatPageChannelUrl = (state: OtsUIState) => state.uiChatPage.channelUrl
